/**
 * The coin balance as the top-bar pills print it. Every one of them sits at
 * x 982 with the fullscreen button at 1100, which leaves room for about nine
 * digits — and an admin can now give 1 000 000 000 (spec 2026-10-06). So a
 * balance of ten million or more is shortened: 12.5M, 1.25B. Rounded DOWN,
 * so the label never shows more than the player has.
 */
export function coinLabel(n: number): string {
  if (n < 10_000_000) return String(n);
  const [div, unit] = n < 1_000_000_000 ? [1_000_000, 'M'] : [1_000_000_000, 'B'];
  const shown = Math.floor((n / div) * 100) / 100;
  return `${shown}${unit}`;
}
